<div class="bb-sidebar-search">
  <bb-search-box-ui
    placeholder="Search"
    [showSearch]="false"
    [showClear]="true"
    [typeaheadOptions]="typeaheadOptions"
    (submit)="navigateToQuery($event)"
  ></bb-search-box-ui>
</div>
